import {
  DUPLICATED_CUSTOMER_EMAIL,
  INVALID_EMAIL_ADDRESS,
  UNKNOWN_EMAIL_ADDRESS,
}                             from '../../const/email_const';

export const getErrorDescription = (resultReason) => {
  if (resultReason === DUPLICATED_CUSTOMER_EMAIL) {
    return 'Email is already in use';
  } if (resultReason === INVALID_EMAIL_ADDRESS) {
    return 'Invalid Email Address';
  } if (resultReason === UNKNOWN_EMAIL_ADDRESS) {
    return 'Unknown Email Address';
  }
  return 'Email Verification Failed';
};



// WEBPACK FOOTER //
// ./src/components/EmailUpdateFormModal/EmailUpdateFormUtil.jsx